<template>
	<div>
		<div class="flex align-items-center justify-content-between mb-2 flex-wrap gap-2">
			<WSubTitle text="Total payments (TPn) by billing period" />
			<span class="text-sm text-color-secondary">Last {{ series.length }} non-trial periods · SAR</span>
		</div>
		<div v-if="!hasData" class="dash-empty">
			<i class="mdi mdi-cash-multiple dash-empty-icon" />
			<p>No settlement payments yet. Run TCM for one or more billing periods.</p>
		</div>
		<div v-else id="dash-payments-chart">
			<apexchart
				type="bar"
				height="320"
				:options="chartOptions"
				:series="chartSeries"
			/>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent, PropType } from 'vue'
	import { DashboardPaymentPoint } from '@/brokers/DashboardBroker'

	export default defineComponent({
		name: 'DashChartPayments',
		props: {
			series: {
				type: Array as PropType<DashboardPaymentPoint[]>,
				default: () => [],
			},
		},
		computed: {
			hasData(): boolean {
				return (this.series || []).some((p) => p.tpn != null)
			},
			categories(): string[] {
				return (this.series || []).map((p) => p.period_name)
			},
			chartSeries(): Array<{ name: string; data: Array<number | null> }> {
				return [
					{
						name: 'TPn',
						data: (this.series || []).map((p) => p.tpn),
					},
					{
						name: 'Invoice total',
						data: (this.series || []).map((p) => p.invoice_total),
					},
				]
			},
			chartOptions(): Record<string, unknown> {
				return {
					chart: {
						type: 'bar',
						height: 320,
						toolbar: { show: true },
					},
					colors: ['#2563eb', '#64748b'],
					plotOptions: {
						bar: { horizontal: false, columnWidth: '55%', borderRadius: 3 },
					},
					dataLabels: { enabled: false },
					xaxis: { categories: this.categories },
					yaxis: {
						title: { text: 'Amount (SAR)' },
						labels: {
							formatter: (v: number) =>
								v == null ? '' : Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 }),
						},
					},
					tooltip: {
						y: {
							formatter: (v: number) =>
								v == null ? '—' : Number(v).toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' SAR',
						},
					},
					legend: { position: 'top' },
				}
			},
		},
	})
</script>

<style scoped>
	.dash-empty {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 2rem 1rem;
		color: var(--text-color-secondary);
		gap: 0.5rem;
		border: 1px dashed var(--surface-border);
		border-radius: 6px;
	}
	.dash-empty-icon {
		font-size: 2rem;
		opacity: 0.5;
	}
</style>
